import { Layout } from 'Components/Layout/Layout'
import { VehiclesContainer } from 'Containers/VehiclesContainer/VehiclesContainer'
import React from 'react'

export const Vehicles = () => {
  return (
    <Layout>
        <VehiclesContainer/>
    </Layout>
  )
}

